import { motion } from "framer-motion";

const STEPS = [
  { n: "01", title: "Discover", desc: "AI finds the audience owners across five platforms." },
  { n: "02", title: "Qualify", desc: "Filter for true product-audience fit, not vanity reach." },
  { n: "03", title: "Research", desc: "Deep intelligence on their audience, themes and gaps." },
  { n: "04", title: "Value", desc: "Decide what you can give before you ever ask." },
  { n: "05", title: "Relationship", desc: "Engage authentically. Build recognition and trust." },
  { n: "06", title: "Partnership", desc: "Propose a collaboration that serves their audience." },
  { n: "07", title: "Lead", desc: "Deliver the masterclass, guide or interview. Capture interest." },
  { n: "08", title: "Sale", desc: "Convert qualified attention into customers." },
  { n: "09", title: "Revenue", desc: "Attribute every dollar back to the partner that earned it." },
];

export default function Journey() {
  return (
    <section id="method" data-testid="journey-section" className="border-t border-white/10 bg-[#0A0A0A]">
      <div className="mx-auto max-w-7xl px-6 py-24 lg:px-10 lg:py-32">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.7 }}
          className="max-w-2xl"
        >
          <p className="text-[11px] font-semibold uppercase tracking-[0.24em] text-[#D4AF37]">
            The Kingdom Method
          </p>
          <h2 className="mt-4 font-serif text-3xl font-semibold leading-tight sm:text-4xl lg:text-5xl">
            One philosophy. Nine deliberate moves.
          </h2>
          <p className="mt-5 text-base leading-relaxed text-zinc-400">
            Not mass posting. Not mass messaging. A disciplined, AI-guided protocol that turns
            other people&rsquo;s trusted audiences into your distribution infrastructure.
          </p>
        </motion.div>

        <div className="mt-16 grid gap-px border border-white/10 bg-white/10 sm:grid-cols-2 lg:grid-cols-3">
          {STEPS.map((s, i) => (
            <motion.div
              key={s.n}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-40px" }}
              transition={{ duration: 0.5, delay: i * 0.06 }}
              data-testid={`journey-step-${s.title.toLowerCase()}`}
              className="group bg-[#0A0A0A] p-8 transition-colors duration-300 hover:bg-[#121212]"
            >
              <div className="flex items-baseline justify-between">
                <span className="font-serif text-sm italic text-[#D4AF37]">{s.n}</span>
                <span className="h-px w-10 bg-white/15 transition-colors duration-300 group-hover:bg-[#D4AF37]/60" />
              </div>
              <h3 className="mt-5 font-serif text-2xl font-semibold">{s.title}</h3>
              <p className="mt-3 text-sm leading-relaxed text-zinc-400">{s.desc}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
